export class Lock {
  queue: any[];
  locked: boolean;

  constructor() {
    this.queue = [];
    this.locked = false;
  }

  acquire() {
    return new Promise(resolve => {
      this.queue.push(resolve);
      this._next();
    });
  }

  release() {
    this.locked = false;
    this._next();
  }

  _next() {
    if (!this.locked && this.queue.length > 0) {
      this.locked = true;
      const resolve = this.queue.shift();
      resolve();
    }
  }
}
